import React, { useState } from "react";
import { Modal, Button } from "antd";

const FullPlanComparison = props => {
    const [visible, setVisible] = useState(false);
    const { buttonText, title } = props;
    return (
        <div style={{ textAlign: "center" }}>
            <Button type="link" onClick={() => setVisible(true)}>
                {buttonText}
            </Button>
            <Modal
                title={title}
                visible={visible}
                maskClosable
                footer={null}
                onCancel={() => setVisible(false)}
            >
                {props.children}
            </Modal>
        </div>
    );
};

export default FullPlanComparison;
